module.exports = __webpack_public_path__ + "img/ico-success.ebfcbff9.svg";